<template>
  <div
    class="
      tw-min-w-8 tw-w-8 tw-flex tw-justify-center tw-items-center tw-text-base
    "
  >
    <span
      v-bind="$attrs"
      class="
        handle
        group/handle
        active:tw-cursor-grabbing
        tw-cursor-grab tw-select-none tw-grid tw-grid-cols-2 tw-gap-0.5 tw-p-0.5
      "
      :class="[
        compact ? 'tw-grid-rows-2' : 'tw-grid-rows-4',
        {
          'tw-invisible': !alwaysVisible,
          'group-hover:tw-visible': !alwaysVisible && !dragging,
        },
      ]"
    >
      <i
        v-for="i in dotCount"
        :key="i"
        class="
          tw-w-[3px]
          tw-h-[3px]
          tw-rounded-full
          tw-transition-colors
          tw-bg-sf-neutral-light-1
          group-hover/handle:tw-bg-sf-neutral-dark-1
        "
      />
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

interface Props {
  // Required, because getting it wrong is invisible until you drag: while a drag
  // is in flight this stops hover from revealing handles, so they don't flash in
  // under the cursor as it passes rows. Pass `false` under `alwaysVisible`,
  // where hover plays no part.
  dragging: boolean
  compact?: boolean
  // Shows the handle unconditionally, for lists where reordering is a primary
  // action rather than a hover affordance.
  alwaysVisible?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  compact: false,
  alwaysVisible: false,
})

const dotCount = computed(() => (props.compact ? 4 : 8))
</script>
